// import { Notifications } from ''
import {
  Currencies,
  Notifications,
} from "@orbital/games-frontend-library"
import { logger } from "../../../helpers/logger"

export const checkRegEx = (n: string, regex: any) => {
  return (
    regex.reg.test(n) ||
    n === "" ||
    (() => {
      logger.log(regex.errorMsg)
      return false
    })()
  )
}
export const checkMaxMin = (
  n: string,
  max: string,
  min: string,
  handleNotification: any,
  type: string,
  prec: number,
  currency?: string,
  isZero?: boolean,
) => {
  if ((+n < +min || n === "") && !isZero) {
    type === "bet" &&
      handleNotification(
        Notifications.minStake + (+min).toFixed(prec) + " " + currency,
      )
    type === "cashout" &&
      handleNotification(
        `Cashout at must be more than bet amount Minimum value is 1.01`,
      )
    // ${+n < 1 ? 1.01 + Currencies[currency] : (+n * 1.01) + Currencies[currency]}
    return min
  } else if (+n > +max) {
    type === "bet" &&
      handleNotification(
        Notifications.maxStake + (+max).toFixed(prec) + " " + currency,
      )
    type === "cashout" &&
      handleNotification(
        `Cashout at must be more than bet amount Maximum value is ${max}${Currencies[currency]}`,
      )
    return max
  } else {
    return n.toString().replace(/,/g, ".")
  }
}
export const checkOnlyDot = (str: any): boolean =>
  (str[0] === "." && str.length === 1) || (str[0] === "," && str.length === 1)

export const checkStartWithZeros = (str: any): string => {
  if (str[0] === "0" && str[1] !== "." && str[1] === "0") {
    const q: string = "" + str.slice(1, str.length)
    return checkStartWithZeros(q)
  } else {
    return str
  }
}
export const checkForEmpty = (str: any): boolean => str.length === 0
export const checkForLengthAfterDot = (n: string, toFix: number) => {
  if (n.indexOf(".") !== -1) {
    if (n.split(".")[1].length <= toFix) {
      return true
    }
    return false
  }
  return true
}

export const checkisNaN = (str: string): boolean => isNaN(Number(str))
